export const UnitsMap: Record<string, { suffix: string }> = {
  Kilogram: {
    suffix: 'Kg',
  },
  Liter: {
    suffix: 'L',
  },
};
